import { createContext } from "react";

interface AuthContextValue {
  token: string | null;
  isAuthenticated: boolean;
  login: (token: string) => void;
  logout: () => void;
  isTokenExpired: () => boolean;
}

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined,
);
